<template>
  <component
    :is="stepComponent">
  </component>
</template>

<script setup>

import { reactive, computed, ref, defineExpose } from 'vue'

import Step1 from "@/components/builder/products/kitchens/TypeAndLayout.vue";
import KitchenStep2 from "@/components/builder/products/kitchens/kitchen/WallSpace.vue";
import KitchenStep3 from "@/components/builder/products/kitchens/kitchen/Sections.vue";
import KitchenStep4 from "@/components/builder/products/kitchens/kitchen/Design.vue";
import CustomKitchenStep2 from "@/components/builder/products/custom/Details.vue";
import CustomKitchenStep3 from "@/components/builder/products/custom/Design.vue";
import Quote from "@/components/builder/Quote.vue";
import Prepare from "@/components/builder/Prepare.vue";

const comps = {
  Step1,
  KitchenStep2,
  KitchenStep3,
  KitchenStep4,
  CustomKitchenStep2,
  CustomKitchenStep3,
  Quote,
  Prepare,
};

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const stepComponent = computed(() => {
  if (builder.mode == 'quote') return comps['Quote'];
  if (builder.mode == 'prepare') return comps['Prepare'];
  if (builder.step <= 1) return comps[builder.stepComponentName]
  return comps[builder.currentProductHandle + builder.stepComponentName]
})

</script>
